module.exports = __webpack_public_path__ + "static/media/LivWeb_GraceBeck-6.0c901635.JPG";